import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_AD_UNIT_PREBID_STACK: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnitPrebidStack($input: UpdateAdUnitPrebidStackInput!) {
    updateAdUnitPrebidStack(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
